var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C4.875 0.5 2.375 3 2.375 6.125V8.625C1.3125 8.625 0.5 9.4375 0.5 10.5V18.625C0.5 19.6875 1.3125 20.5 2.375 20.5H13.625C14.6875 20.5 15.5 19.6875 15.5 18.625V10.5C15.5 9.4375 14.6875 8.625 13.625 8.625V6.125C13.625 3 11.125 0.5 8 0.5ZM14.25 10.5V18.625C14.25 19 14 19.25 13.625 19.25H2.375C2 19.25 1.75 19 1.75 18.625V10.5C1.75 10.125 2 9.875 2.375 9.875H3H13H13.625C14 9.875 14.25 10.125 14.25 10.5ZM3.625 8.625V6.125C3.625 3.6875 5.5625 1.75 8 1.75C10.4375 1.75 12.375 3.6875 12.375 6.125V8.625H3.625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.75C6.9375 11.75 6.125 12.5625 6.125 13.625C6.125 14.4375 6.625 15.125 7.375 15.375V16.75C7.375 17.125 7.625 17.375 8 17.375C8.375 17.375 8.625 17.125 8.625 16.75V15.375C9.375 15.125 9.875 14.4375 9.875 13.625C9.875 12.5625 9.0625 11.75 8 11.75ZM8 14.25C7.625 14.25 7.375 14 7.375 13.625C7.375 13.25 7.625 13 8 13C8.375 13 8.625 13.25 8.625 13.625C8.625 14 8.375 14.25 8 14.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.922173a97b4e408ba410f0024fd11c57.svg";
export { ForwardRef as ReactComponent };